var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.className},[_vm._t("default"),_vm._v(" "),_c('label',{attrs:{"for":_vm.inputId || _vm.name}}),_vm._v(" "),_c('input-file')],2)}
var staticRenderFns = []

export { render, staticRenderFns }